import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import LoadingButton from '@mui/lab/LoadingButton'
import LockResetIcon from '@mui/icons-material/LockReset'
import { Error, Spinner } from '../../common/Error'
import Hero from '../../common/Hero'
import {
  doForgotPassword,
} from './authSlice';

export const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading, error, success } = useSelector((state) => state.auth.forgot_password)
  
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .email('Email is invalid'),
  })

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(validationSchema)
  })

  const submitForm = (data) => {
    data.email = data.email.toLowerCase()
    dispatch(doForgotPassword(data))
  }

  const content = success
    ? (
      <Box>
        <Typography component="p" variant="p">
          Please check your email for the link to reset your password
        </Typography>
      </Box>
    )
    : (
      <Box
        component='form'
        noValidate='noValidate'
        onSubmit={handleSubmit(submitForm)}
      >
        <Typography component="p" variant="p">
          Enter your email and we will send you a link to reset your password
        </Typography>
        <TextField
          id='email'
          autoComplete='email'
          name='email'
          {...register('email')}
          required
          fullWidth
          label='Email'
          margin='normal'
          error={errors.email ? true : false}
          helperText={errors.email?.message}
        />
        <LoadingButton
          size='large'
          type='submit'
          fullWidth
          variant='contained'
          loading={loading}
          loadingPosition="start"
          startIcon={<LockResetIcon />}
          sx={{ mt: 4, mb: 4 }}
        >
          Reset password
        </LoadingButton>
      </Box>
    )

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Hero />
        <Typography component="h1" variant="h6">
          Reset your Babel Chat password
        </Typography>
        {content}
        <Link
          component={NavLink}
          to={'/login'}
          variant="body1"
          sx={{
            mt: 2,
            mb: 2
          }}
        >
          {`Remembered your password? Log in`}
        </Link>
      </Box>
    </Container>
  )
}

